import { useState, SyntheticEvent } from 'react';
import PageSeo from '@framework/seo/PageSeo';
import { Link } from '@framework/router/Next/Link';
import staticUrls from '@finsight/urls/static';
import metaTags from '@/finsight/ui/common/metaTagsConstants';
import MetaSchema from '@/finsight/ui/common/components/MetaSchema';
import getHomepageMetaSchema from '@/finsight/ui/components/staticPages/Homepage/getHomepageMetaSchema';
import CookiesBanner from '@framework/cookie-consent/CookiesBanner';

import styles from '@/finsight/ui/components/staticPages/Homepage/homepage.module.scss';

const Homepage = () => {
  const [offsetLeft, setOffsetLeft] = useState<number>(0);

  const changeOffsetLeft = (e: SyntheticEvent) => {
    const target = e.target as HTMLElement;
    let { offsetLeft, offsetWidth } = target;
    setOffsetLeft(offsetLeft + (offsetWidth / 2));
  };

  return (
    <>
      <MetaSchema schema={ getHomepageMetaSchema() } />
      <PageSeo { ...getHomepageMetaSchema() } { ...metaTags.getFisightHomePage() } />
      <div className={ styles.backgroundImg } />
      <div className={ styles.pageContentWrapper }>
        <div className={ styles.pageTitleContainer }>
          <h1>Illuminating <br /> Capital Markets</h1>
        </div>
        <div className={ styles.pageNavigationContainer }>
          <Link
            title="About Us"
            onMouseEnter={ changeOffsetLeft }
            className={ styles.link }
            to={ staticUrls.getAboutUrl() }
          >
            About Us
          </Link>
          <Link
            title="Solutions"
            onMouseEnter={ changeOffsetLeft }
            className={ styles.link }
            to={ staticUrls.getSolutionsUrl() }
          >
            Solutions
          </Link>
          <Link
            title="Contact"
            onMouseEnter={ changeOffsetLeft }
            className={ styles.link }
            to={ staticUrls.getContactUrl() }
          >
            Contact
          </Link>
          <i
            style={ {
              left: offsetLeft,
            } }
            className={ styles.bottomLine }
          />
        </div>
      </div>
      <CookiesBanner />
    </>
  );
};

export default Homepage;
